/* eslint-disable react/prop-types */
import ClearIcon from "@mui/icons-material/Clear";
import { LoadingButton } from "@mui/lab";
import { CircularProgress, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useFormik } from "formik";
import * as React from "react";
import { useSelector } from "react-redux";
import * as yup from "yup";
import { apipost } from "../../../service/api";


const Add = (props) => {
  const { open, handleClose, setUserAction } = props
  const userid = sessionStorage.getItem('user_id');
  const userdata = JSON.parse(sessionStorage.getItem('user'));
  const userDetails = useSelector((state) => state?.userDetails?.data)
  const [isLoading, setIsLoading] = React.useState(false);

  // -----------  validationSchema
  const validationSchema = yup.object({
    type_name: yup.string().required("Project Type Name is required"),
    charge: yup.string().required("Project Charge is required"),
  });

  // -----------   initialValues
  const initialValues = {
    type_name: "",
    charge: "",
    createdBy: userid,
  };

  // add contact api
  const addType = async (values) => {
    setIsLoading(true)

    try {
      const data = values;
      const result = await apipost('api/projecttypes/add', data)
      setUserAction(result)

      if (result && result.status === 201) {
        formik.resetForm();
        handleClose();
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false)
  }

  // formik
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      addType(values)
    },
  });


  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle
          id="scroll-dialog-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Add New Project Type</Typography>
          <Typography>
            <ClearIcon
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            />
          </Typography>
        </DialogTitle>

        <DialogContent dividers>
          <form>
            <Grid
              container
              rowSpacing={3}
              columnSpacing={{ xs: 0, sm: 5, md: 4 }}
            >
              <Grid item xs={12} sm={6} md={6}>
                <FormLabel>Project Type Name <span style={{ color: "red" }}>*</span></FormLabel>
                <TextField
                  id="type_name"
                  name="type_name"
                  size="small"
                  maxRows={10}
                  fullWidth
                  value={formik.values.type_name}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.type_name &&
                    Boolean(formik.errors.type_name)
                  }
                  helperText={
                    formik.touched.type_name && formik.errors.type_name
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <FormLabel>Project Charge <span style={{ color: "red" }}>*</span></FormLabel>
                <TextField
                  id="charge"
                  name="charge"
                  size="small"
                  type='number'
                  maxRows={10}
                  fullWidth
                  value={formik.values.charge}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.charge &&
                    Boolean(formik.errors.charge)
                  }
                  helperText={
                    formik.touched.charge && formik.errors.charge
                  }
                />
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>

          <LoadingButton onClick={formik.handleSubmit} variant='contained' color='primary' disabled={!!isLoading}>
            {isLoading ? <CircularProgress size={27} /> : 'Save'}
          </LoadingButton>
          <Button
            type="reset"
            variant="outlined"
            style={{ textTransform: "capitalize" }}
            color="error"
            onClick={() => {
              formik.resetForm()
              handleClose()
            }}
          >
            Cancle
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Add